<template>
    <div>
        <b-form @submit.prevent="search">
            <b-form-group
                label="Search"
                label-for="search"
            >
                <b-input-group>
                    <b-form-input ref="search-term" type="search" v-model="search_term" :disabled="searching" required />
                    <b-input-group-append>
                        <b-btn type="submit" variant="outline-secondary" :disabled="searching">
                            <font-awesome-icon :icon="['fad', 'search']" />
                        </b-btn>
                    </b-input-group-append>
                    <b-input-group-append v-if="searched">
                        <b-btn variant="outline-danger" :disabled="searching" @click.prevent="clearSearch">
                            <font-awesome-icon :icon="['fad', 'backspace']" />
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

            <div v-if="searching" class="mb-3">
                <b-spinner label="Spinning"></b-spinner>
            </div>

            <div v-else :class="{ 'bulk-search-results': bulk }">
                <b-list-group v-if="filtered_related_media && filtered_related_media.length" class="my-3">
                    <b-list-group-item
                        v-for="(item, index) in filtered_related_media"
                        :key="itemKey(item) || index"
                        class="d-flex align-items-center"
                    >
                        <related-media-item
                            ref="related-media-item"
                            :publication="publication"
                            :item="item"
                            :type="type"
                            :article_related_media="article_related_media"
                            :bulk="bulk"
                            :selected="isSelected(item)"
                            @link="linkItem"
                            @unlink="unlinkItem"
                            @select="selectItem"
                            @deselect="deselectItem"
                        />
                    </b-list-group-item>
                </b-list-group>

                <b-alert variant="danger" :show="searched && !filtered_related_media.length">
                    0 results
                </b-alert>
            </div>
        </b-form>
    </div>
</template>

<style lang="scss" scoped>
.bulk-search-results {
    max-height: calc(100vh - 400px);
    overflow-y: auto;
}
</style>

<script>
import RelatedMediaItem from '@/components/modals/article/related_media/Item'

export default {
    data: () => ({
        related_media: [],

        search_term: '',

        searching: false,
        searched: false,

        selected_related_media_keys: []
    }),
    props: {
        publication: {},
        article: {},
        type: {},
        article_related_media: {},
        bulk: {
            type: Boolean,
            default: false
        }
    },
    components: {
        RelatedMediaItem
    },
    computed: {
        filtered_related_media() {
            return _.filter(this.related_media, item => {
                if(!this.type){
                        return item;
                }
                else if(this.type && item.type == this.type) {
                    return item
                }
            })
        }
    },
    methods: {
        async search() {
            if (!this.search_term) {
                return
            }

            try {
                this.searched = false
                this.searching = true
                this.related_media = []
                this.resetSelectedItems()

                const sanitizedSearch = encodeURIComponent(this.search_term)
                const response = await this.axios.get(`/api/articles/search_related_media/${sanitizedSearch}`)
                if (response.data) {
                    this.related_media = response.data
                }

                this.searched = true
                this.searching = false
            } catch (e) {
                this.searched = false
                this.searching = false
            }
        },
        clearSearch() {
            this.search_term = ''

            this.related_media = []
            this.resetSelectedItems()

            this.searched = false

            this.focusSearch()
        },
        linkItem (item, width, position) {
            this.$set(item, 'linking', true)

            this.$emit('link', item, width, position)
        },
        unlinkItem (item) {
            this.$set(item, 'linking', false)

            this.$emit('unlink', item)
        },
        itemKey (item) {
            return item.id || item.media_id || item.dam_id || item.url
        },
        isSelected (item) {
            return _.includes(this.selected_related_media_keys, this.itemKey(item))
        },
        selectItem (item) {
            if (!this.bulk) {
                return
            }

            const key = this.itemKey(item)

            if (!_.includes(this.selected_related_media_keys, key)) {
                this.selected_related_media_keys.push(key)
                this.emitSelectedChange()
            }
        },
        deselectItem (item) {
            if (!this.bulk) {
                return
            }

            const key = this.itemKey(item)
            const original_length = this.selected_related_media_keys.length

            this.selected_related_media_keys = _.without(this.selected_related_media_keys, key)

            if (this.selected_related_media_keys.length !== original_length) {
                this.emitSelectedChange()
            }
        },
        resetSelectedItems() {
            this.selected_related_media_keys = []
            this.emitSelectedChange()
        },
        emitSelectedChange() {
            if (!this.bulk) {
                return
            }

            this.$emit('selected-change', this.selected_related_media_keys.length)
        },
        async addSelectedItems() {
            if (!this.bulk) {
                return []
            }

            let item_components = this.$refs['related-media-item'] || []
            let selected_items = []

            if (!Array.isArray(item_components)) {
                item_components = [item_components]
            }

            for (const item_component of item_components) {
                if (item_component && this.isSelected(item_component.item)) {
                    const selected_item = await item_component.addSelectedItem()

                    if (selected_item === false) {
                        return false
                    }

                    selected_items.push(selected_item)
                }
            }

            return selected_items
        },
        focusSearch() {
            if (this.$refs['search-term']) {
                this.$refs['search-term'].focus()
            }
        }
    },
    mounted () {
        this.focusSearch()
    }
}
</script>
